const targetIdMap = {
  jobName: 'job-name',
  mainArticle: {
    prefix: 'main-article-',
    title: 'main-article-title',
    body: 'main-article-body',
    photo: 'main-article-photo',
    caption: 'main-article-caption',
    pr: {
      10: 'main-article-pr-occupation-inexperience',
      d0: 'main-article-pr-business-inexperience',
      11: 'main-article-pr-secondary-new-graduates',
      12: 'main-article-pr-no-educational-background',
      1000: 'main-article-pr-experienced-only',
      15: 'main-article-pr-training',
      25: 'main-article-pr-no-transfer',
      1001: 'main-article-pr-remote',
      28: 'main-article-pr-holidays',
      29: 'main-article-pr-less-overtime',
      18: 'main-article-pr-maternity-leave',
      c1: 'main-article-pr-casual-clothes',
      22: 'main-article-pr-female-manager',
      96: 'main-article-pr-holiday-120-date',
      19: 'main-article-pr-childcare',
      c0: 'main-article-pr-blank',
      c2: 'main-article-pr-short-working',
      17: 'main-article-pr-allowance',
      1002: 'main-article-pr-side-job',
      1003: 'main-article-pr-national-certification'
    }
  },
  description: {
    prefix: 'description-',
    job: {
      prefix: 'description-job-',
      catchCopy: 'description-job-catch-copy',
      detail: 'description-job-detail'
    },
    workflow: 'description-workflow',
    attention: {
      prefix: 'description-attention-',
      title: 'description-attention-title',
      text: 'description-attention-text'
    },
    improved: 'description-improved',
    strength: {
      prefix: 'description-strength-',
      language: 'description-strength-language',
      education: 'description-strength-education',
      license: 'description-strength-license',
      femaleManager: 'description-strength-female-manager'
    }
  },
  requirements: {
    prefix: 'requirements-',
    employment: 'requirements-employment',
    employmentRemarks: 'requirements-employment-remarks',
    regular: 'requirements-regular',
    salary: 'requirements-salary',
    salaryEx: 'requirements-salary-ex',
    place: 'requirements-place',
    transportation: 'requirements-transportation',
    transfer: 'requirements-transfer',
    workLocation: 'requirements-work-location',
    combinedAllSalaryBulkPlace: 'requirements-combined-all-salary-bulk-place',
    combinedAllBulkPlace: 'requirements-combined-all-bulk-place',
    requiredSkill: 'requirements-required-skill',
    welcomeSkill: 'requirements-welcome-skill',
    recruitExample: 'requirements-recruit-example',
    post: 'requirements-post',
    ageRatio: 'requirements-age-ratio',
    sexRatio: 'requirements-sex-ratio',
    officeHours: 'requirements-office-hours',
    overTime: 'requirements-over-time',
    mother: 'requirements-mother',
    vacation: 'requirements-vacation',
    maternity: 'requirements-maternity',
    condition: 'requirements-condition'
  },
  freeTopics: {
    prefix: 'free-topics-',
    title: 'free-topics-title',
    body: 'free-topics-body',
    photo: 'free-topics-photo'
  },
  feature: {
    prefix: 'feature-',
    environment: {
      scale: 'feature-environment-scale',
      overTime: 'feature-environment-over-time',
      salary: 'feature-environment-salary',
      atmosphere: 'feature-environment-atmosphere',
      desk: 'feature-environment-desk',
      outside: 'feature-environment-outside',
      standing: 'feature-environment-standing'
    },
    work: {
      idea: 'feature-work-idea',
      speed: 'feature-work-speed',
      retail: 'feature-work-retail',
      contact: 'feature-work-contact',
      team: 'feature-work-team',
      myself: 'feature-work-myself',
      accountability: 'feature-work-accountability'
    }
  },
  report: {
    prefix: 'report-',
    staffComment: {
      prefix: 'report-staff-comment-',
      name: 'report-staff-comment-name',
      body: 'report-staff-comment-body'

    },
    improve: 'report-improve'
  },
  realIntention: {
    prefix: 'real-intention-',
    answer: 'real-intention-answer',
    genderAndCareer: 'real-intention-gender-and-career'
  },
  companyInfo: {
    prefix: 'company-info-',
    intro: {
      prefix: 'company-info-intro-',
      catchCopy: 'company-info-intro-catch-copy',
      text: 'company-info-intro-text',
      image: 'company-info-intro-image'
    },
    businessContent: 'company-info-business-content',
    established: 'company-info-established',
    capital: 'company-info-capital',
    sale: 'company-info-sale',
    employeeNumber: 'company-info-employee-number',
    averageAge: 'company-info-average-age',
    midCareerPercentage: 'company-info-mid-career-percentage',
    representative: 'company-info-representative',
    representativeProfile: 'company-info-representative-profile',
    note: 'company-info-note',
    hp: 'company-info-hp',
    images: {
      prefix: 'company-info-images-',
      image: 'company-info-images-image',
      caption: 'company-info-images-caption'
    }
  },
  selection: {
    prefix: 'selection-',
    process: 'selection-process',
    interview: {
      prefix: 'selection-interview-',
      zip: 'selection-interview-zip',
      address: 'selection-interview-address',
      person: 'selection-interview-person',
      tel: 'selection-interview-tel'
    },
    inquiry: {
      prefix: 'selection-inquiry-',
      url: 'selection-inquiry-url',
      zip: 'selection-inquiry-zip',
      address: 'selection-inquiry-address',
      person: 'selection-inquiry-person',
      tel: 'selection-inquiry-tel',
      email: 'selection-inquiry-email'
    },
    link: 'selection-link'
  },
  environment: {
    prefix: 'environment-',
    woman: 'environment-woman',
    officer: 'environment-officer',
    overtime: 'environment-overtime',
    pto: 'environment-pto',
    maternity: 'environment-maternity',
    lengthService: 'environment-length-service',
    certification: 'environment-certification',
    action: 'environment-action',
    job: {
      suffix: '-job'
    },
    company: {
      suffix: '-company'
    }
  },
  categorySetting: {
    prefix: 'category-setting-',
    point: {
      prefix: 'category-setting-point-',
      salaryCode: 'category-setting-point-salary-code',
      jobName: 'category-setting-point-job-name',
      education: 'category-setting-point-education',
      age: 'category-setting-point-age',
      salary: 'category-setting-point-salary',
      externalJobName: 'category-setting-point-external-job-name'
    },
    about: {
      prefix: 'category-setting-about-',
      formalName: 'category-setting-about-formal-name',
      displayName: 'category-setting-about-display-name',
      businessName: 'category-setting-about-business-name'
    },
    pr: {
      prefix: 'category-setting-pr-',
      normal: 'category-setting-pr-normal',
      ura: 'category-setting-pr-ura',
      uraEngineer: 'category-setting-pr-ura-engineer',
      uraService: 'category-setting-pr-ura-service'
    },
    applyUrl: 'category-setting-url',
    question: 'category-setting-question',
    provided: 'category-setting-provided'
  },
  matching: {
    prefix: 'matching-',
    profile: {
      gender: 'matching-profile-gender',
      age: 'matching-profile-age',
      address: 'matching-profile-address',
      educationalBackground: 'matching-profile-educational-background',
      graduate: 'matching-profile-graduate',
      educationalSearch: {
        prefix: 'matching-profile-educational-search-',
        word: 'matching-profile-educational-search-word',
        label: 'matching-profile-educational-search-label'
      },
      educationDepartment: 'matching-profile-education-department',
      work: {
        prefix: 'matching-profile-work-',
        list: [
          'matching-profile-work-status',
          'matching-profile-work-income',
          'matching-profile-work-employment'
        ]
      },
      homeMoving: 'matching-profile-home-moving',
      married: 'matching-profile-married',
      child: 'matching-profile-child',
      changeJobCount: 'matching-profile-change-job-count'
    },
    experienced: {
      occupation: {
        prefix: 'matching-experienced-occupation-',
        list: [
          'matching-experienced-occupation-sales',
          'matching-experienced-occupation-service',
          'matching-experienced-occupation-creative',
          'matching-experienced-occupation-clerk',
          'matching-experienced-occupation-consultant',
          'matching-experienced-occupation-engineers',
          'matching-experienced-occupation-medical'
        ]
      },
      business: 'matching-experienced-business'
    },
    language: {
      toeic: 'matching-language-toeic',
      toefl: 'matching-language-toefl',
      english: 'matching-language-english',
      other: 'matching-language-other'
    },
    skill: {
      121000000: 'matching-skill-sales',
      122000000: {
        prefix: 'matching-skill-office-',
        list: [
          'matching-skill-office-clerical',
          'matching-skill-office-planning',
          'matching-skill-office-finance',
          'matching-skill-office-general',
          'matching-skill-office-legal'
        ]
      },
      123000000: 'matching-skill-web',
      124000000: {
        prefix: 'matching-skill-property-',
        list: [
          'matching-skill-property-finance',
          'matching-skill-property-estate',
          'matching-skill-property-medical'
        ]
      },
      125000000: {
        prefix: 'matching-skill-engineer-',
        list: [
          'matching-skill-engineer-it',
          'matching-skill-engineer-electrical',
          'matching-skill-engineer-semiconductor',
          'matching-skill-engineer-machinery',
          'matching-skill-engineer-materials',
          'matching-skill-engineer-pharmaceutical',
          'matching-skill-engineer-architecture',
          'matching-skill-engineer-other'
        ]
      }
    },
    license: 'matching-license',
    workStyle: {
      prefix: 'matching-work-style-',
      list: [
        'matching-work-style-scale',
        'matching-work-style-overtime',
        'matching-work-style-reward',
        'matching-work-style-atmosphere',
        'matching-work-style-desk',
        'matching-work-style-outside',
        'matching-work-style-standing',
        'matching-work-style-idea',
        'matching-work-style-speed',
        'matching-work-style-sell',
        'matching-work-style-contact',
        'matching-work-style-team',
        'matching-work-style-oneself',
        'matching-work-style-responsible'
      ]
    },
    desired: {
      prefix: 'matching-desired-',
      occupation: {
        prefix: 'matching-desired-occupation',
        list: [
          'matching-desired-occupation-sales',
          'matching-desired-occupation-service',
          'matching-desired-occupation-creative',
          'matching-desired-occupation-clerk',
          'matching-desired-occupation-consultant',
          'matching-desired-occupation-engineers',
          'matching-desired-occupation-medical'
        ]
      },
      business: 'matching-desired-business',
      workPlace: 'matching-desired-work-place',
      employment: 'matching-desired-employment'
    },
    freeWord: {
      prefix: 'matching-free-word-',
      word: 'matching-free-word-word',
      label: 'matching-free-word-label'
    },
    registrationDate: 'matching-registration-date'
  }
}

const tooltips = {
  description: '仕事内容本文、POINT01本文、POINT02本文の合計で1000文字以内'
}

// 平均値（定数）
const averages = {
  environment: { /* データで見る働く環境 */
    overtime: 13,
    pto: 72,
    maternity: 83,
    lengthService: 10
  }
}

const areaLabelMap = {
  [targetIdMap.mainArticle.photo]: 'メイン写真',
  [`${targetIdMap.freeTopics.photo}-1`]: 'フリートピックス[1]写真',
  [`${targetIdMap.freeTopics.photo}-2`]: 'フリートピックス[2]写真',
  [targetIdMap.feature.environment.scale]: '会社規模',
  [targetIdMap.feature.environment.overTime]: '残業',
  [targetIdMap.feature.environment.salary]: '報酬について',
  [targetIdMap.feature.environment.atmosphere]: '職場の雰囲気',
  [targetIdMap.feature.environment.desk]: 'デスクワークの割合',
  [targetIdMap.feature.environment.outside]: '外出する仕事の割合',
  [targetIdMap.feature.environment.standing]: '立ち仕事の割合',
  [targetIdMap.feature.work.idea]: 'アイデアや企画力が必要',
  [targetIdMap.feature.work.speed]: '速さや正確性が必要',
  [targetIdMap.feature.work.retail]: 'モノやサービスを売る仕事',
  [targetIdMap.feature.work.contact]: '多くの人と接する仕事',
  [targetIdMap.feature.work.team]: 'チームや仲間と進める仕事',
  [targetIdMap.feature.work.myself]: '自分ひとりで進める仕事',
  [targetIdMap.feature.work.accountability]: '厳しくても責任のある仕事',
  [targetIdMap.companyInfo.intro.image]: '企業紹介写真',
  [`${targetIdMap.companyInfo.images.image}-1`]: '会社写真[1]',
  [`${targetIdMap.companyInfo.images.image}-2`]: '会社写真[2]',
  [`${targetIdMap.companyInfo.images.image}-3`]: '会社写真[3]',
  [`${targetIdMap.environment.woman}${targetIdMap.environment.company.suffix}`]: '女性社員の割合',
  [`${targetIdMap.environment.woman}${targetIdMap.environment.job.suffix}`]: '女性社員の割合',
  [`${targetIdMap.environment.officer}${targetIdMap.environment.company.suffix}`]: '女性役員・管理職の割合',
  [`${targetIdMap.environment.overtime}${targetIdMap.environment.company.suffix}`]: '残業時間（平均）',
  [`${targetIdMap.environment.overtime}${targetIdMap.environment.job.suffix}`]: '残業時間（平均）',
  [`${targetIdMap.environment.pto}${targetIdMap.environment.company.suffix}`]: '有給取得率',
  [`${targetIdMap.environment.pto}${targetIdMap.environment.job.suffix}`]: '有給取得率',
  [`${targetIdMap.environment.maternity}${targetIdMap.environment.company.suffix}`]: '育休取得率',
  [`${targetIdMap.environment.lengthService}${targetIdMap.environment.company.suffix}`]: '女性社員の平均勤続年数',
  [`${targetIdMap.environment.certification}${targetIdMap.environment.company.suffix}`]: '国認定',
  [`${targetIdMap.environment.action}${targetIdMap.environment.company.suffix}`]: 'その他の取り組み'
}

const textMaxMap = {
  [targetIdMap.jobName]: 35, // 求人名
  [targetIdMap.mainArticle.title]: 50, // メインタイトル
  [targetIdMap.mainArticle.body]: 300, // メイン記事
  [targetIdMap.mainArticle.caption]: 50, // メイン写真キャプション
  [targetIdMap.description.job.catchCopy]: 100, // 仕事内容キャッチ
  [targetIdMap.description.job.detail]: 1000, // 仕事内容本文(*合計1000文字)
  [targetIdMap.description.workflow]: 400, // 一日の仕事の流れ
  [targetIdMap.description.attention.title]: 30, // POINT0xキャッチ
  [targetIdMap.description.attention.text]: 1000, // POINT0x本文(*合計1000文字)
  [targetIdMap.description.improved]: 150, // この仕事で磨ける経験・能力
  [targetIdMap.description.strength.language]: 200, // 語学を生かせる
  [targetIdMap.description.strength.education]: 200, // 教育制度について
  [targetIdMap.description.strength.license]: 200, // 資格取得支援について
  [targetIdMap.description.strength.femaleManager]: 200, // 女性管理職について
  [targetIdMap.requirements.employmentRemarks]: 300, // 試用期間の雇用形態備考
  [targetIdMap.requirements.regular]: 200, // 正社員登用について
  [targetIdMap.requirements.salary]: 550, // 給与
  [targetIdMap.requirements.salaryEx]: 160, // 給与例
  [targetIdMap.requirements.place]: 550, // 勤務地
  [targetIdMap.requirements.transportation]: 1000, // 詳細・交通
  [targetIdMap.requirements.transfer]: 40, // 転勤の可能性
  [targetIdMap.requirements.requiredSkill]: 500, // 応募資格
  [targetIdMap.requirements.welcomeSkill]: 300, // あると望ましい経験・能力
  [targetIdMap.requirements.recruitExample]: 150, // 過去に採用した転職者例
  [targetIdMap.requirements.post]: 100, // 配属部署
  [targetIdMap.requirements.ageRatio]: 50, // 年齢構成
  [targetIdMap.requirements.sexRatio]: 50, // 男女比
  [targetIdMap.requirements.officeHours]: 250, // 勤務時間
  [targetIdMap.requirements.overTime]: 200, // 残業について
  [targetIdMap.requirements.mother]: 200, // 育児と両立しやすい
  [targetIdMap.requirements.vacation]: 300, // 休日休暇
  [targetIdMap.requirements.maternity]: 200, // 産休育休活用例
  [targetIdMap.requirements.condition]: 450, // 待遇・福利厚生・その他
  [targetIdMap.freeTopics.title]: 25, // フリートピックスタイトル
  [targetIdMap.freeTopics.body]: 200, // フリートピックス本文
  [targetIdMap.report.staffComment.name]: 20, // 担当者名字
  [targetIdMap.report.staffComment.body]: 200, // レポート本文
  [targetIdMap.report.improve]: 150, // この仕事で磨ける経験・能力
  [targetIdMap.companyInfo.intro.catchCopy]: 50, // 企業紹介キャッチ
  [targetIdMap.companyInfo.intro.text]: 200, // 企業紹介本文
  [targetIdMap.companyInfo.businessContent]: 550, // 事業内容
  [targetIdMap.companyInfo.established]: 50, // 設立
  [targetIdMap.companyInfo.capital]: 20, // 資本金
  [targetIdMap.companyInfo.sale]: 50, // 売上高
  [targetIdMap.companyInfo.employeeNumber]: 50, // 従業員数
  [targetIdMap.companyInfo.averageAge]: 50, // 平均年齢
  [targetIdMap.companyInfo.midCareerPercentage]: 50, // 中途入社者の割合
  [targetIdMap.companyInfo.representative]: 100, // 代表者
  [targetIdMap.companyInfo.representativeProfile]: 100, // 代表者略歴
  [targetIdMap.companyInfo.note]: 50, // 備考
  [targetIdMap.companyInfo.images.caption]: 50, // 会社写真キャプション
  [targetIdMap.selection.process]: 500, // 選考プロセス
  [targetIdMap.selection.interview.address]: 100, // 住所（面接会場）
  [targetIdMap.selection.interview.person]: 25, // 担当者（面接会場）
  [targetIdMap.selection.interview.tel]: 50, // TEL（面接会場）
  [targetIdMap.selection.inquiry.address]: 100, // 住所（問い合わせ）
  [targetIdMap.selection.inquiry.person]: 25, // 担当者（問い合わせ）
  [targetIdMap.selection.inquiry.tel]: 50, // TEL（問い合わせ）
  [targetIdMap.selection.inquiry.email]: 256 // E-mail（問い合わせ）
}

export {
  targetIdMap,
  tooltips,
  averages,
  areaLabelMap,
  textMaxMap
}
